import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Dictionary } from '@/src/lib/dictionary/types';
import { GetUser } from '@/src/lib/auth/types';
import { DeserializedCompanyUser } from '@/src/lib/company-user/types';
import { DeserializedCart } from '@/src/lib/cart/glue/types/deserialized';
import { assemblePricingReferenceOptions } from '@/src/lib/company-business-units/business/pricing-reference';
import classNames from 'classnames';
import AccountChangeForm from '@/src/app/components/Header/AccountChangeForm/AccountChangeForm';
import { DeserializedStore } from '@/src/lib/store/types';
import { getCountryNameFromCode, getRegionNameFromCode } from '@/src/lib/store/utils/country.utils';
function AccountCard(t0) {
  const $ = _c(50);
  const {
    dict,
    user,
    companyUser,
    cart,
    lang,
    store
  } = t0;
  let pricingReferences;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== companyUser.companies || $[1] !== companyUser.companyBusinessUnitAddresses || $[2] !== companyUser.companyBusinessUnits || $[3] !== companyUser.isDefault || $[4] !== dict || $[5] !== store || $[6] !== user.user?.customer.firstName || $[7] !== user.user?.customer.lastName) {
    const companyBusinessUnit = companyUser.companyBusinessUnits.at(0);
    let t9;
    if ($[17] !== companyUser.companies) {
      t9 = companyUser.companies.at(0);
      $[17] = companyUser.companies;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    const company = t9;
    const companyBusinessUnitAddress = companyUser.companyBusinessUnitAddresses?.at(0);
    pricingReferences = assemblePricingReferenceOptions(companyBusinessUnit, dict);
    if ($[19] !== companyUser.isDefault) {
      t6 = classNames("w-full bg-gray-100 p-6", {
        "border-l-4 border-solid border-primary": companyUser.isDefault
      });
      $[19] = companyUser.isDefault;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t7 = "account-card";
    const t10 = companyBusinessUnit?.accountNumber;
    if ($[21] !== dict.userProfile.menu.account || $[22] !== t10) {
      t8 = <h3 className="label text-lg!">{dict.userProfile.menu.account} {t10}</h3>;
      $[21] = dict.userProfile.menu.account;
      $[22] = t10;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t1 = "mt-6";
    const t11 = user.user?.customer.firstName;
    const t12 = user.user?.customer.lastName;
    if ($[24] !== t11 || $[25] !== t12) {
      t2 = <span>{t11} {t12}</span>;
      $[24] = t11;
      $[25] = t12;
      $[26] = t2;
    } else {
      t2 = $[26];
    }
    if ($[27] !== companyBusinessUnit) {
      t3 = companyBusinessUnit ? <><br /><span>{companyBusinessUnit.name}</span></> : null;
      $[27] = companyBusinessUnit;
      $[28] = t3;
    } else {
      t3 = $[28];
    }
    if ($[29] !== company) {
      t4 = company ? <><br /><span>{company.name}</span></> : null;
      $[29] = company;
      $[30] = t4;
    } else {
      t4 = $[30];
    }
    t5 = companyBusinessUnitAddress ? <><br /><span>{companyBusinessUnitAddress.zipCode}{" "}<span className="font-semibold">{companyBusinessUnitAddress.city}</span></span>{companyBusinessUnitAddress.region ? <><br /><span>{getRegionNameFromCode(companyBusinessUnitAddress.region, store, companyBusinessUnitAddress.iso2Code) ?? companyBusinessUnitAddress.region}</span></> : null}<br /><span>{getCountryNameFromCode(companyBusinessUnitAddress.iso2Code, store)}</span></> : null;
    $[0] = companyUser.companies;
    $[1] = companyUser.companyBusinessUnitAddresses;
    $[2] = companyUser.companyBusinessUnits;
    $[3] = companyUser.isDefault;
    $[4] = dict;
    $[5] = store;
    $[6] = user.user?.customer.firstName;
    $[7] = user.user?.customer.lastName;
    $[8] = pricingReferences;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    pricingReferences = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[31] !== t1 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5) {
    t9 = <p className={t1}>{t2}{t3}{t4}{t5}</p>;
    $[31] = t1;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== cart || $[38] !== companyUser.id || $[39] !== companyUser.isDefault || $[40] !== dict || $[41] !== lang || $[42] !== pricingReferences) {
    t10 = <AccountChangeForm isCurrentAccount={companyUser.isDefault} dict={dict} pricingReferenceOptions={pricingReferences} companyUserId={companyUser.id} cart={cart} lang={lang} />;
    $[37] = cart;
    $[38] = companyUser.id;
    $[39] = companyUser.isDefault;
    $[40] = dict;
    $[41] = lang;
    $[42] = pricingReferences;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  let t11;
  if ($[44] !== t10 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8 || $[48] !== t9) {
    t11 = <div className={t6} data-testid={t7}>{t8}{t9}{t10}</div>;
    $[44] = t10;
    $[45] = t6;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  return t11;
}
export default AccountCard;